import {ApplicationConfig, importProvidersFrom} from '@angular/core';
import {provideRouter, withComponentInputBinding, withHashLocation, withInMemoryScrolling} from '@angular/router';

import {routes} from './app.routes';
import {provideClientHydration} from "@angular/platform-browser";
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi} from "@angular/common/http";
import {AbstractLoggerService, AuthInterceptor, provideAuth} from "angular-auth-oidc-client";
import {AuthLoggerService} from "./security/auth-logger.service";
import {FeatherModule} from "angular-feather";
import {allIcons} from "angular-feather/icons";
import {loadingInterceptor} from "./interceptors/loading_interceptor";
import {provideAnimations} from "@angular/platform-browser/animations";
import {provideAnimationsAsync} from "@angular/platform-browser/animations/async";
import {Http404Interceptor} from "./shared/commons/interceptor/http404-interceptor";
import {environment} from "../environments/environment";
import {http5xxInterceptor} from "./interceptors/http5xx_interceptor";

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      routes,
      withHashLocation(),
      withInMemoryScrolling({scrollPositionRestoration: 'enabled'}),
      withComponentInputBinding()
    ),
    provideClientHydration(),
    provideHttpClient(
      // withFetch(),
      withInterceptors([
        loadingInterceptor,
        http5xxInterceptor
      ]),
      withInterceptorsFromDi()
    ),
    {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: Http404Interceptor, multi: true},
    provideAnimations(),
    provideAnimationsAsync(),
    provideAuth({
      config: {
        secureRoutes: [environment.serverUrl, ''],
        authority: environment.oidcIssuerUrl,
        redirectUrl: window.location.origin + '/#/callback',
        postLogoutRedirectUri: window.location.origin,
        clientId: environment.clientId,
        scope: 'openid profile email', // 'openid profile offline_access ' + your scopes
        responseType: 'code',
        silentRenew: true,
        useRefreshToken: true,
        autoUserInfo: true,
        renewUserInfoAfterTokenRenew: true,
        ignoreNonceAfterRefresh: true,
        renewTimeBeforeTokenExpiresInSeconds: 60,
        startCheckSession: true,
        triggerRefreshWhenIdTokenExpired: true,
        logLevel: environment.ngOidcLogLevel,
      },
    }),
    {provide: AbstractLoggerService, useClass: AuthLoggerService},
    importProvidersFrom(FeatherModule.pick(allIcons)),
  ]
};

